(function () {
  var refreshTimer = null;

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function renderNode(node) {
    var threshold = toNumber(node.dataset.rpThreshold);
    if (threshold <= 0) {
      node.hidden = true;
      return;
    }

    node.hidden = false;
    var cartTotal = toNumber(node.dataset.rpCartTotal);
    var variantPrice = node.dataset.rpFreeShippingMode === 'product'
      ? toNumber(node.dataset.rpVariantPrice)
      : 0;
    var total = cartTotal + variantPrice;
    var remaining = Math.max(0, threshold - total);
    var progress = Math.min(100, Math.max(0, total / threshold * 100));

    if (node.dataset.rpFreeShippingMode === 'product') {
      var copy = node.querySelector('.rp-shipping-nudge__text');
      if (copy) {
        copy.replaceChildren();
        var strong = document.createElement('strong');
        var small = document.createElement('small');
        if (remaining > 0) {
          strong.textContent = (node.dataset.rpMessageFreeFrom || 'Offerte dès [amount]').replace('[amount]', formatMoney(threshold));
          small.textContent = (node.dataset.rpMessageRemaining || 'Encore [amount] pour en profiter.').replace('[amount]', formatMoney(remaining));
        } else {
          strong.textContent = node.dataset.rpFreeShippingRule === 'guaranteed'
            ? (node.dataset.rpMessageReachedGuaranteed || 'Livraison offerte appliquée.')
            : (node.dataset.rpMessageReachedConditional || 'Seuil atteint. Les conditions seront confirmées au paiement.');
          small.textContent = '';
        }
        var protection = document.createElement('small');
        protection.className = 'rp-shipping-nudge__protection';
        protection.textContent = 'Envoi protégé.';
        copy.append(strong, small, protection);
      }
      return;
    }

    var message = node.querySelector('.rp-free-ship__msg');
    if (message) {
      message.classList.toggle('rp-free-ship__msg--ok', remaining === 0);
      message.replaceChildren();
      if (remaining > 0) {
        var remainingMessage = (node.dataset.rpMessageRemaining || 'Encore [amount] pour en profiter.').replace('[amount]', formatMoney(remaining));
        message.textContent = remainingMessage;
      } else {
        message.textContent = node.dataset.rpFreeShippingRule === 'guaranteed'
          ? (node.dataset.rpMessageReachedGuaranteed || 'Livraison offerte appliquée.')
          : (node.dataset.rpMessageReachedConditional || 'Seuil atteint. Les conditions seront confirmées au paiement.');
      }
    }
    var bar = node.querySelector('.rp-free-ship__bar');
    if (bar) bar.style.setProperty('--rp-free-ship-progress', progress + '%');
  }

  function renderAll() {
    document.querySelectorAll('[data-rp-free-shipping]').forEach(renderNode);
  }

  function setCartTotal(total) {
    document.querySelectorAll('[data-rp-free-shipping]').forEach(function (node) {
      node.dataset.rpCartTotal = String(toNumber(total));
    });
    renderAll();
  }

  function updateFromCart(cartState) {
    if (!cartState || typeof cartState !== 'object') {
      renderAll();
      return;
    }

    var total = cartState.items_subtotal_price;
    if (!Number.isFinite(Number(total))) total = cartState.total_price;
    setCartTotal(total || 0);
  }

  function refreshCart() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
      fetch(cartUrl + '.js', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
        .then(function (cart) { setCartTotal(cart.items_subtotal_price || cart.total_price || 0); })
        .catch(renderAll);
    }, 80);
  }

  function bindPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    if (PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        document.querySelectorAll('[data-rp-free-shipping-mode="product"]').forEach(function (node) {
          node.dataset.rpVariantPrice = String(toNumber(variant.price));
        });
        renderAll();
      });
    }
    if (PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var cartState = event && (event.cartData || (event.data && event.data.cartData));
        if (cartState) updateFromCart(cartState);
        else refreshCart();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderAll();
    bindPubSub();
  });
  document.addEventListener('shopify:section:load', renderAll);
  document.addEventListener('retroparty:cart-upsell-added', refreshCart);
  document.addEventListener('cart:updated', refreshCart);
  window.RPFreeShipping = { render: renderAll, refreshCart: refreshCart, updateFromCart: updateFromCart };
  if (document.readyState !== 'loading') renderAll();
})();
